import { useEffect, useState } from "react";
import VisibilitySensor from "react-visibility-sensor";
import { StyledAnimatedIconsGridComponent } from "./animated-icons-grid-component.scss";
import AnimatedIcon from "./animated-icon/animated-icon";

const AnimatedIconsGridComponent = (props) => {
  // isInView is a prop we get from the visibility sensor in base-layout-segment-component.js
  const { iconsArray, isInView } = props;

  return (
    <StyledAnimatedIconsGridComponent className="animated-icons-grid-component">
      <div className="icons-container">
        {iconsArray?.map((icon, index) => {
          return (
            <div key={index} className="icon-container">
              <AnimatedIcon iconAsset={icon?.iconAsset} {...icon} startAnimation={isInView} />
            </div>
          );
        })}
      </div>
    </StyledAnimatedIconsGridComponent>
  );
};

export default AnimatedIconsGridComponent;
